/**
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import MuiLink from "@mui/material/Link";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import RenderSocials from "./renderSocials";

// Images
import logo1 from "assets/images/logos/logo1.png";
import logoKulturerbe from "assets/images/logos/logo-kulturerbe2.png";
import logoNvhb from "assets/images/logos/logo-nvhb-rund.png";

function CenteredFooter({ links, light }) {
  let iconColor = "secondary";

  const renderLinks = links.map((link) => (
    <MKTypography
      key={link.name}
      // component={MuiLink}
      component={link.route ? Link : MuiLink}
      to={link.route ? link.route : ""}
      href={link.href}
      variant="body2"
      color={light ? "white" : "secondary"}
      fontWeight="regular"
    >
      {link.name}
    </MKTypography>
  ));

  return (
    <MKBox component="footer" py={2}>
      <MKBox component="section" height="auto" pb={5}>
        <Container>
          <Grid container spacing={3} justifyContent="space-around" alignItems="center">
            <Grid item xs={5} md={3} lg={2}>
              <a href="/pages/HomeSite">
                <MKBox component="img" src={logo1} opacity={0.7} width="100%" />
              </a>
            </Grid>
            <Grid item xs={7} md={5} lg={4}>
              <a
                href="https://www.unesco.de/kultur-und-natur/immaterielles-kulturerbe/immaterielles-kulturerbe-deutschland/fastnacht"
                target="_blank"
                rel="noreferrer"
              >
                <MKBox component="img" src={logoKulturerbe} opacity={0.7} width="100%" />
              </a>
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
              <a
                href="https://www.narrenvereinigung-hegau-bodensee.de/"
                target="_blank"
                rel="noreferrer"
              >
                <MKBox component="img" src={logoNvhb} opacity={0.7} width="100%" />
              </a>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={8}>
          <Stack display="flex" direction="row" justifyContent="center" spacing={3} mt={1} mb={3}>
            <RenderSocials color="secondary" />
          </Stack>
        </Grid>
        <Grid item xs={10} lg={8}>
          <Stack
            direction="row"
            flexWrap="wrap"
            justifyContent="center"
            spacing={{ xs: 2, lg: 3, xl: 6 }}
            mb={3}
          >
            {renderLinks}
          </Stack>
        </Grid>
        <Grid item xs={12} lg={8} sx={{ textAlign: "center" }}>
          <MKTypography variant="body2" color={light ? "white" : "secondary"}>
            Brauchtumsverein Bachrose Bietingen e.V - Mitglied der Narrenvereinigung Hegau-Bodensee
          </MKTypography>
        </Grid>
      </Grid>
    </MKBox>
  );
}

// Setting default values for the props of CenteredFooter
CenteredFooter.defaultProps = {
  links: [
    { name: "Impressum", route: "/pages/ImpressumSite" },
    { name: "Datenschutz", route: "/pages/DataPrivacySite" },
    { name: "Cookie-Richtlinien", route: "/pages/CookiesSite" },
    // { name: "Kontakt", route: "/pages/ContactSite" },
  ],
  light: false,
};

// Typechecking props for the CenteredFooter
CenteredFooter.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
  light: PropTypes.bool,
};

export default CenteredFooter;
